import React, { useEffect } from 'react'

import Layout from 'src/components/common/Layout'
import SEO from 'src/components/common/SEO'

import { useSelector } from 'react-redux'
import { createUrl } from 'src/modules/utils/createUrl'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import { selectAnalyticsParameters } from 'src/modules/reducers/analytics'
import { filterCTAParams } from 'src/modules/utils/filterCTAParams'
import StatusTemplate from '../status'

export const pageTitle = 'Watch Premier League soccer live'
export const pageDescription =
  'See every match all season long. Stream live TV without cable. DVR included. No contract, cancel anytime.'

const CanadaTemplateRedirect = ({ location }) => {
  const originalParams = useSelector(selectAnalyticsParameters)
  const parsedParams = originalParams && filterCTAParams(originalParams)
  const destination = 'https://www.fubo.tv/stream/canada/'
  let ctaURL = createUrl(destination, parsedParams)
  let redirectURL = replaceUrlParam(ctaURL, 'source', 'redirect')

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = redirectURL
    }, 3000)
    return () => clearTimeout(timeout)
  }, [location])

  return (
    <Layout market="CA" location={location} noFooter>
      <SEO title={pageTitle} description={pageDescription} />
      <StatusTemplate
        type="redirect_ca"
        title="You're being redirected to Fubo Canada."
        subtitle="It may have different content than Fubo US."
        text={
          <>
            <a href={redirectURL}>Click here</a> if you are not redirected within a few seconds.
          </>
        }
      />
    </Layout>
  )
}

export default CanadaTemplateRedirect
